<template>
  <div class="header">
    <div class="container-fluid">
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">File Management</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">File Management</h4>
          <!-- Button -->
          <b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true">
            <span class="fe fe-file-plus"></span>
            Import File
          </b-button>
          <!-- <b-button v-b-toggle.collapse-1 variant="primary" style="margin-left: 7px">
            <span class="fe fe-sliders"></span>
          </b-button> -->
        </div>
        <b-collapse id="collapse-1">
          <form @submit.prevent="sorting()">
            <div class="row mt-4" style="margin-left: 15px; margin-right: 15px">
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputEmail1" class="form-label">QUESIONER NAME</label>
                  <input type="text" class="form-control" v-model="body.title" />
                </div>
              </div>
            </div>

            <div class="row mb-3" style="margin-right: 15px">
              <div class="col"></div>
              <div class="col-auto">
                <!-- Button -->
                <button type="submit" class="btn btn-danger lift">
                  Filter
                </button>
              </div>
            </div>
            <!-- / .row -->
          </form>
        </b-collapse>
        <vue-good-table :line-numbers="true" :columns="columns" :rows="list.data" :sort-options="{
              enabled: true,
            }" :total-rows="list.totalItems" :pagination-options="{
              enabled: true,
              mode: 'pages',
              position: 'bottom',
              perPage: 10,
              perPageDropdown: [10, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All',
            }" style-class="vgt-table border-0 table" @on-page-change="onPageChange"
          @on-per-page-change="onPageChange">
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>
          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <!-- <b-button class="no-wrap btn-pill" variant="warning" size="sm" @click="updateData(props.row)">
                  <span class="fe fe-edit"></span>
                </b-button> -->
              <b-button class="no-wrap ml-2" variant="info" style="margin-left: 5px" size="sm"
                @click="seeDetail(props.row)">
                <span class="fe fe-info"></span>
              </b-button>
              <b-button class="no-wrap ml-2" variant="warning" style="margin-left: 5px" size="sm"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
              <b-button class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                @click="deleteData(props.row.id)">
                <span class="fe fe-trash-2"></span>
              </b-button>
            </span>
            <span v-else-if="props.column.field === 'petrik_star'">
              <i class="fe fe-star text-warning" style="font-size: 22px;" v-if="props.row.is_default"></i>
            </span>
            <span v-else-if="props.column.field === 'updated'">
              {{ convertMonth(props.row.updated_at) }}
            </span>
          </template>

        </vue-good-table>
      </div>

      <!-- Modal -->
      <b-modal id="modal-1" hide-footer title="File Forms">
        <form @submit.prevent="saveAdd()" v-if="isAdd === true">
          <div class="form-group">
            <label>Ideation <span class="text-danger">*</span></label>
            <v-select :options="ideation" :reduce="(e) => e.id" label="ideation_name" v-model="bodyAdd.ideation_id"
              v-validate="'required'" name="Ideation">
            </v-select>
            <span class="text-sm text-danger"
              v-show="errors.has('Quesioner Name')">{{ errors.first("Quesioner Name") }}</span>
          </div>
          <div class="form-group">
            <label>Upload File <span class="text-danger">*</span></label>
            <input type="file" class="form-control" multiple @input="fileUploader">
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea name="" id="" class="form-control" v-model="bodyAdd.description"></textarea>
          </div>
          <div class="form-group">
            <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
              v-if="isLoading == false">
              Save
            </button>
            <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </button>
          </div>
        </form>

        <form @submit.prevent="saveUpdate()" v-else>
          <div class="form-group">
            <label>Ideation <span class="text-danger">*</span></label>
            <v-select :options="ideation" :reduce="(e) => e.id" label="ideation_name" v-model="bodyUpdate.ideation_id"
              v-validate="'required'" name="Ideation" disabled>
            </v-select>
            <span class="text-sm text-danger"
              v-show="errors.has('Quesioner Name')">{{ errors.first("Quesioner Name") }}</span>
          </div>
          <div class="form-group">
            <label>Upload File <span class="text-danger">*</span></label>
            <input type="file" class="form-control" multiple @input="fileUploader2">
          </div>
          <div class="form-group">
            <label>Saved File</label>
            <div class="mt-1 row" v-for="(item, index) in bodyUpdate.files" :key="index">
              <div class="col-11"><a :href="item.url" target="_blank">{{ item.name }}</a></div>
              <div class="col-1" v-if="bodyUpdate.files.length > 0">
                <b-button variant="danger" size="sm" @click="deleteFiles(item.name)"><span class="fe fe-trash"></span>
                </b-button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea name="" id="" class="form-control" v-model="bodyUpdate.description"></textarea>
          </div>
          <div class="form-group">
            <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
              v-if="isLoading == false">
              Save
            </button>
            <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading....
            </button>
          </div>
        </form>
      </b-modal>
      <b-modal id="modal-detail" size="xl" hide-footer title="Detail File">
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">Ideation Subject</label>
              <p>{{ details && details.ideation ? details.ideation.ideation_name : '-' }}</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">Create by</label>
              <p>{{ details && details.user ? details.user.fullname : '-' }}</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">Role</label>
              <p>
                {{ details && details.user && details.user.roleMap && details.user.roleMap.roles ? details.user.roleMap.roles.roles_name : '-' }}
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">Last Update</label>
              <p>{{ details ? convertMonth(details.updated_at) : '' }}</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">Description</label>
              <p>{{ details ? details.description : '' }}</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label class="font-weight-bold">File</label>
              <ul>
                <li v-for="(item, index) in details.files" :key="index"><a :href="item.url"
                    target="_blank">{{ item.name }}</a></li>
              </ul>
              <p></p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    name: "file",
    computed: {
      list() {
        return this.$store.getters["file/list"];
      },
      ideation() {
        return this.$store.getters["file/ideation"];
      },
      detail() {
        return this.$store.getters["quesioner/detail"];
      },
    },
    data() {
      return {
        body: {
          page: 1,
          limit: 10,
          // order: "",
          title: ''
        },
        bodyAdd: {
          ideation_id: "",
          description: "",
          files: []
        },
        bodyUpdate: {
          id: "",
          ideation_id: "",
          description: "",
          files: [],
          tempfiles: []
        },
        id: "",
        details: {},
        isAdd: true,
        isLoading: false,
        row: [{
            name: 'Ideation Percobaan',
            by: 'Kemas Rafli',
            role: 'PMO & Governance',
            at: '14 August 2024'
          },
          {
            name: 'Ideation Coba',
            by: 'Muhammad Irfansyah',
            role: 'Genta Gendis',
            at: '14 August 2024'
          }
        ],
        columns: [{
            label: "Ideation Subject",
            field: "ideation.ideation_name",
            thClass: "table-header no-wrap text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "Upload by",
            field: "user.fullname",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "Role",
            field: "user.roleMap.roles.roles_name",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "Last Update",
            field: "updated",
            thClass: "table-header no-wrap w-90 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "ACTION",
            field: "action",
            thClass: "table-header no-wrap text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
            sortable: false
          },
        ],
        listquestion: [],
        intangibleUpdate: [],
        tangibleUpdate: [],
        timeDelUpdate: [],
      };
    },

    mounted() {
      this.getList();
      this.getListIdeation();
    },
    methods: {
      //action
      updateData(props) {
        this.isAdd = false;
        this.bodyUpdate.id = props.id;
        this.bodyUpdate.ideation_id = props.ideation_id
        this.bodyUpdate.files = props.files
        this.bodyUpdate.description = props.description
        // this.getDetail(props.id);
        setTimeout(() => {
          this.$bvModal.show("modal-1");
        }, 600);
      },

      seeDetail(dat) {
        console.log(dat);

        this.details = dat
        setTimeout(() => {
          this.$bvModal.show('modal-detail')
        }, 100);
      },

      async fileUploader(event) {
        this.bodyAdd.files = event.target.files;
      },
      async fileUploader2(event) {
        this.bodyUpdate.tempfiles = event.target.files;
      },
      saveAdd() {
        this.$validator.validateAll().then(async (res) => {
          if (!res) return false;
          try {
            this.isLoading = true;
            const formData = new FormData();
            formData.append("ideation_id", this.bodyAdd.ideation_id);
            formData.append("description", this.bodyAdd.description);
            for (let file of this.bodyAdd.files) {
              formData.append("files", file); // note, no square-brackets
            }
            this.$store.dispatch("file/CREATE_DATA", formData).then((resp) => {
              this.$swal("Saved", "Your input has been saved", "success").then(
                (resp) => {
                  this.isLoading = false;
                  this.bodyAdd = {
                    ideation_id: "",
                    description: '',
                    files: '',
                  }
                  this.getList();
                  this.$bvModal.hide("modal-1");
                }
              );
            });
          } catch (error) {
            console.log(error);
            this.isLoading = false
            this.$swal("Error", "Error while add data", "error");
          }
        });
      },

      saveUpdate() {
        this.$validator.validateAll().then(async (res) => {
          if (!res) return false;
          try {
            this.isLoading = true;
            const formData = new FormData();
            formData.append("ideation_id", this.bodyUpdate.ideation_id);
            formData.append("description", this.bodyUpdate.description);
            for (let file of this.bodyUpdate.tempfiles) {
              formData.append("files", file); // note, no square-brackets
            }
            let body = {
              id: this.bodyUpdate.id,
              formdata: formData
            }
            this.$store.dispatch("file/UPDATE_FILE", body).then((resp) => {
              this.$swal("Saved", "Your input has been saved", "success").then(
                (resp) => {
                  this.isLoading = false;
                  this.bodyUpdate = {
                    ideation_id: "",
                    description: '',
                    files: '',
                  }
                  this.getList();
                  this.$bvModal.hide("modal-1");
                }
              );
            });
          } catch (error) {
            this.isLoading = false
            this.$swal("Error", "Error while add data", "error");
          }
        });
      },

      deleteData(id) {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00D97E",
          cancelButtonColor: "#E63757",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("file/DELETE_DATA", id)
              .then((resp) => {
                this.getList();
                this.$swal("Deleted!", "Your file has been deleted", "success");
              })
              .catch((resp) => {
                this.$swal("Error", "Error while delete data", "error");
              });
          }
        });
      },
      deleteFiles(name) {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00D97E",
          cancelButtonColor: "#E63757",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            let body = {
              name: name,
              id: this.bodyUpdate.id
            }
            this.$store
              .dispatch("file/DELETE_FILES", body)
              .then((resp) => {
                this.$bvModal.hide('modal-1')
                this.getList();
                this.$swal("Deleted!", "Your file has been deleted", "success");
              })
              .catch((resp) => {
                this.$swal("Error", "Error while delete file", "error");
              });
          }
        });
      },

      // hit api
      getList() {
        this.$store.dispatch("file/GET_LIST", this.body);
      },

      getListIdeation() {
        this.$store.dispatch("file/GET_LIST_IDEATION");
      },

      getDetail(id) {
        this.$store.dispatch("quesioner/GET_DETAIL", id).then(() => {
          console.log(this.detail.quesioner_question);
          this.intangibleUpdate = this.detail.quesioner_question.filter(this.filterIntangible2)
          this.tangibleUpdate = this.detail.quesioner_question.filter(this.filterTangible2)
          this.timeDelUpdate = this.detail.quesioner_question.filter(this.filterDelivery2)
          this.bodyUpdate = {
            id: this.detail.id,
            is_default: this.detail.is_default,
            title: this.detail.title,
            description: this.detail.description,
            // division: this.detail.division,
            // console.log(this.detail);
            // questions: this.detail.quesioner_question,
          };
        });
      },

      // filter
      filterPage() {},

      convertMonth(dat) {
        return moment(dat).format('DD MMMM YYYY')
      },

      sorting() {
        this.getList();
      },

      // Pagination
      onPageChange(payload) {
        this.body.limit = payload.currentPerPage;
        this.body.page = payload.currentPage;
        this.getList();
      },
    },
  };
</script>